<template>
  <div class="dashboard-rewards-card">
    <b-card no-body>
      <b-card-header class="d-flex flex-row justify-content-between bg-white">
        <b-card-title class="m-0"><strong>Reward Shop</strong></b-card-title>
        <b-card-title class="m-0">{{ balance }} <rewards-coin/></b-card-title>
      </b-card-header>
      <b-card-body class="py-0">
        <b-alert class="border-success my-3 p-0" show variant="transparent" v-if="availableReward && availableReward.id">
          <b-media>
            <template v-slot:aside>
              <b-img v-if="availableReward.image && availableReward.image.fileLocation" height="128" width="128"
                :src="availableReward.image.fileLocation | cdn('resize', 128, 128)" :alt="availableReward.title"/>
              <b-img v-else blank blank-color="#ccc" height="128" width="128"/>
            </template>
            <b-card-body class="py-3 pl-0">
              <b-card-title>{{ availableReward.title }}</b-card-title>
              <b-btn :to="{ name: 'RewardsIndex' }" variant="primary">
                {{ availableReward.tokenCost }} <rewards-coin/>
              </b-btn>
            </b-card-body>
          </b-media>
        </b-alert>
        <b-alert class="border-danger my-3 p-0" show variant="transparent" v-if="nextReward && nextReward.id">
          <b-media>
            <template v-slot:aside>
              <b-img v-if="nextReward.image && nextReward.image.fileLocation" height="128" width="128"
                :src="nextReward.image.fileLocation | cdn('resize', 128, 128)" :alt="nextReward.title"/>
              <b-img v-else blank blank-color="#ccc" height="128" width="128"/>
            </template>
            <b-card-body class="py-3 pl-0 text-muted">
              <b-card-title class="text-muted">{{ nextReward.title }}</b-card-title>
              <p>{{ nextReward.tokenCost - balance }} <rewards-coin/> still needed</p>
              <b-progress :value="balance" :max="nextReward.tokenCost" variant="primary"/>
            </b-card-body>
          </b-media>
        </b-alert>
      </b-card-body>
      <b-card-footer class="d-flex flex-row justify-content-center bg-white">
        <router-link :to="{ name: 'RewardsIndex' }">View Reward Shop</router-link>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { RewardsCoin } from '@src/components/Icons';

export default {
  props: {
    balance: {
      type: Number,
      default: 0,
    },
    rewards: {
      type: Array,
      required: true,
    },
    claimed: {
      type: Array,
    },
  },
  components: {
    RewardsCoin,
  },
  computed: {
    availableReward() {
      return this.rewards.filter(r => r && r.id).find(reward => {
        const { tokenCost, oneTimeClaim } = reward;

        const hasClaimed = (Array.isArray(this.claimed) && this.claimed.length)
          ? this.claimed.find(r => r && r.reward && r.reward.id === reward.id)
          : null;
        if (oneTimeClaim && hasClaimed) {
          return false;
        }

        return this.balance > tokenCost;
      });
    },
    nextReward() {
      return this.rewards.find(({ tokenCost }) => tokenCost > this.balance);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/rewards/Dashboard.vue